export namespace DisplaysteuerungEntityTypes {
    export const ROLLE_ENTITY = 'DISP.ROLLE';
    export const BEREICH_ENTITY = 'DISP.BEREICH';
    
}

